var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#328332"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.989 16.553l-6.721-.577 6.72-3.802v4.379zm0 4.46v6.94C13.652 24.315 11.076 20.311 9 17.07c2.45 1.38 5.008 2.823 6.989 3.944zm0-10.068L9 14.845 15.989 4v6.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.601,
    fillRule: "nonzero",
    d: "M22.71 15.976l-6.721.577v-4.379l6.72 3.802zm-6.721 5.038c1.98-1.12 4.537-2.564 6.988-3.944-2.076 3.242-4.652 7.246-6.988 10.882v-6.938zm0-10.069V4l6.988 10.845-6.988-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.989 16.553l6.72-.577-6.72 3.775z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.603,
    d: "M15.988 16.553l-6.721-.577 6.721 3.775z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/etc.a60abf522e814d173e57f5065a56573a.svg";
export { ForwardRef as ReactComponent };